module.exports = __webpack_public_path__ + "static/img/audio.6f4d1cba.gif";